import script from "./ViewGroupTalkAttendees.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewGroupTalkAttendees.vue?vue&type=script&setup=true&lang=js"

import "./ViewGroupTalkAttendees.vue?vue&type=style&index=0&id=0aa8dcb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aa8dcb2"]])

export default __exports__